import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const OverlayedLoadingButton = ({
  children,
  onClick,
  trackableKey,
  'aria-label': ariaLabel,
  loading,
  disabled,
  failed,
  use,
  size
}) => {
  const trackEvent = useTrackEvent();
  const onTrackedEvent = event => {
    trackEvent(trackableKey, {});
    onClick(event);
  };
  return /*#__PURE__*/_jsx(LoadingButton, {
    "aria-label": ariaLabel,
    loading: loading,
    disabled: disabled,
    failed: failed,
    use: use,
    size: size,
    onClick: onTrackedEvent,
    padding: "200",
    children: children
  });
};